import http from "@/http/aisea/axios";
const resource = "/enterprises/assignments/scoring_categories";
import qs from "qs";

/**
 * スコアリングカテゴリ一覧API
 */
export default {
  /**
   * スコアリングカテゴリ一覧取得API
   *
   * @param {Object} params - 以下の条件で絞り込みが可能です。
   * details:
   *   - ITEM
   *   - ITEM_SCORE
   */
  fetch(params) {
    return http.get(`${resource}`, {
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },
};
